/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LoyaltyProgramEnum = {
    SkyMiles: 'SkyMiles',
    MileagePlus: 'MileagePlus',
    AAdvantage: 'AAdvantage',
    MileagePlan: 'MileagePlan',
    MarriottBonvoy: 'Marriott Bonvoy',
    HiltonHonors: 'Hilton Honors',
    IhgOneRewards: 'IHG One Rewards',
    WorldOfHyatt: 'World of Hyatt',
    TrueBlue: 'TrueBlue',
    RapidRewards: 'Rapid Rewards',
    Gold: 'Gold',
    AmexEveryDay: 'Amex EveryDay',
    ThePlatinumCard: 'The Platinum Card',
    BlueBusinessPlus: 'Blue Business Plus',
    BusinessPlatinumCard: 'Business Platinum Card',
    ChaseFreedom: 'Chase Freedom',
    ChaseFreedomUnlimited: 'Chase Freedom Unlimited',
    ChaseFreedomFlex: 'Chase Freedom Flex',
    ChaseFreedomRise: 'Chase Freedom Rise',
    ChaseSapphire: 'Chase Sapphire',
    ChaseSapphirePreferred: 'Chase Sapphire Preferred',
    ChaseSapphireReserve: 'Chase Sapphire Reserve',
    Bilt: 'Bilt',
    WyndhamRewards: 'Wyndham Rewards',
    AccorLiveLimitless: 'Accor Live Limitless',
    InkBusinessCash: 'Ink Business Cash',
    InkBusinessUnlimited: 'Ink Business Unlimited',
    InkBusinessPlus: 'Ink Business Plus',
    InkBusinessPreferred: 'Ink Business Preferred',
    InkBusinessPremier: 'Ink Business Premier',
    ChoicePrivilegesRewards: 'Choice Privileges Rewards',
    BestWesternRewards: 'Best Western Rewards',
    BiltRewards: 'Bilt Rewards',
    ChaseUltimateRewards: 'Chase Ultimate Rewards',
    MembershipRewards: 'Membership Rewards',
    BarclaycardRewards: 'Barclaycard Rewards',
    BarclaycardRewardsProgram: 'Barclaycard Rewards Program',
    CapitalOneRewards: 'Capital One Rewards',
    KrisFlyerPartner: 'KrisFlyer Partner',
    AsiaMiles: 'Asia Miles',
    LeadersClub: 'Leaders Club',
    FlyingBlue: 'Flying Blue',
    BankOfAmericaTravelRewards: 'Bank of America Travel Rewards',
    CitiThankYouRewards: 'Citi ThankYou Rewards',
    FrontierMiles: 'Frontier Miles',
    Aeroplan: 'Aeroplan',
    TheBritishAirwaysClub: 'The British Airways Club',
    FlyingClub: 'Flying Club',
    AerClub: 'AerClub',
    EmiratesSkywards: 'Emirates Skywards',
    PrivilegeClub: 'Privilege Club',
    AviancaLifeMiles: 'Avianca LifeMiles',
    Skypass: 'Skypass',
    AeromexicoRewards: 'Aeromexico Rewards',
    AnaMileageClub: 'ANA Mileage Club',
    MilesMore: 'Miles & More',
    MilesSmiles: 'Miles&Smiles',
    IberiaPlus: 'Iberia Plus',
    QantasFrequentFlyer: 'Qantas Frequent Flyer',
    BankOfAmericaPreferredRewards: 'Bank of America Preferred Rewards',
    VentureOneRewards: 'VentureOne Rewards',
    VentureRewards: 'Venture Rewards',
    VentureXRewards: 'Venture X Rewards',
    CitiPremier: 'Citi Premier',
    CitiDoubleCash: 'Citi Double Cash',
    AmericanExpressGreen: 'American Express Green',
    BusinessGold: 'Business Gold',
    BlueFromAmericanExpress: 'Blue from American Express',
    SmartRewards: 'Smart Rewards',
    CorporatePlatinum: 'Corporate Platinum',
    CorporateGold: 'Corporate Gold',
    BusinessGreen: 'Business Green',
    CenturionCard: 'Centurion Card',
    ChaseSlate: 'Chase Slate',
    ChaseSlateEdge: 'Chase Slate Edge',
    InkPlusBusiness: 'Ink Plus Business',
    CitiSimplicity: 'Citi Simplicity',
    CitiRewards: 'Citi Rewards+',
    CitiThankYouPreferred: 'Citi ThankYou Preferred',
    CitiPrestige: 'Citi Prestige',
    CitiDiamondPreferred: 'Citi Diamond Preferred',
    BankOfAmericaCashRewards: 'Bank of America Cash Rewards',
    BankOfAmericaPremiumRewards: 'Bank of America Premium Rewards',
    BusinessAdvantageTravelRewards: 'Business Advantage Travel Rewards',
    BusinessAdvantageCashRewards: 'Business Advantage Cash Rewards',
    BankAmericard: 'BankAmericard',
    ArrivalPlus: 'Arrival Plus',
    Arrival: 'Arrival',
    UsBankAltitudeReserveVisaInfinite: 'US Bank Altitude Reserve Visa Infinite',
    HertzGoldPlusRewards: 'Hertz Gold Plus Rewards',
    AvisPreferred: 'Avis Preferred',
    EmeraldClub: 'Emerald Club',
    EnterprisePlus: 'Enterprise Plus',
    BudgetFastbreak: 'Budget Fastbreak',
    SixtPlus: 'Sixt Plus',
    AlamoInsiders: 'Alamo Insiders'
} as const;
export type LoyaltyProgramEnum = typeof LoyaltyProgramEnum[keyof typeof LoyaltyProgramEnum];


export function instanceOfLoyaltyProgramEnum(value: any): boolean {
    for (const key in LoyaltyProgramEnum) {
        if (Object.prototype.hasOwnProperty.call(LoyaltyProgramEnum, key)) {
            if (LoyaltyProgramEnum[key as keyof typeof LoyaltyProgramEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LoyaltyProgramEnumFromJSON(json: any): LoyaltyProgramEnum {
    return LoyaltyProgramEnumFromJSONTyped(json, false);
}

export function LoyaltyProgramEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoyaltyProgramEnum {
    return json as LoyaltyProgramEnum;
}

export function LoyaltyProgramEnumToJSON(value?: LoyaltyProgramEnum | null): any {
    return value as any;
}

export function LoyaltyProgramEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): LoyaltyProgramEnum {
    return value as LoyaltyProgramEnum;
}

